import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    // Only update if we're on the new form (not edit)
    const container = document.getElementById("invoiceable-select-container")
    if (container) {
      this.updateSelect()
    }
  }

  updateSelect(event) {
    const type = this.element.value

    // Try to find select in container first (for forms), then by ID (for search)
    const container = document.getElementById("invoiceable-select-container")
    const select = container?.querySelector("select") || document.getElementById("invoiceable_search")

    if (!select) return

    const tomSelectController = this.application.getControllerForElementAndIdentifier(
      select,
      "tom-select"
    )

    if (!type) {
      select.disabled = true
      if (tomSelectController) {
        tomSelectController.loadUrlValue = ""
        tomSelectController.clear()
        tomSelectController.clearOptions()
        tomSelectController.disable()
      }
      return
    }

    select.disabled = false

    // Fetch the appropriate records based on type
    const url = type === "Contact" ? "/contacts.json" : "/companies.json"

    if (tomSelectController) {
      tomSelectController.enable()
      tomSelectController.clear()
      tomSelectController.clearOptions()
      tomSelectController.loadUrlValue = url
      return
    }

    // Fallback for non-Tom Select usage
    select.innerHTML = '<option value="">Select invoiceable</option>'
    fetch(url)
      .then(response => response.json())
      .then(data => {
        data.forEach(item => {
          const option = document.createElement("option")
          option.value = item.id
          const displayName = item.name || `${item.firstname || ""} ${item.lastname || ""}`.trim() || "Unnamed"
          option.textContent = displayName
          select.appendChild(option)
        })
      })
      .catch(error => {
        console.error("Error fetching invoiceables:", error)
      })
  }
}
